const RatingType = {
  USER: 'user',
  DRAFT: 'draft',
  OUTLINE: 'outline',
  PROOF: 'proof',
  ONBOARDING: 'onboarding',
  SAMPLE: 'sample',
};

module.exports = RatingType;
